import type {
  SignupLeadItem,
  SignupLeadListParams,
  SignupLeadListResult,
  SignupLeadNudgeResult,
} from '@/types/signupLead.types';
import { cleanParams } from '@/utils/params.util';

import { apiClient } from './api.service';

export const signupLeadsApi = {
  list: (params: SignupLeadListParams = {}) =>
    apiClient
      .get<SignupLeadListResult>('/admin/signup-leads', {
        params: cleanParams(params as unknown as Record<string, unknown>),
      })
      .then((r) => r.data),

  nudge: (ids: string[]) =>
    apiClient
      .post<SignupLeadNudgeResult>('/admin/signup-leads/nudge', { ids })
      .then((r) => r.data),

  dismiss: (id: string) =>
    apiClient.post<SignupLeadItem>(`/admin/signup-leads/${id}/dismiss`).then((r) => r.data),
};
